<template>
  <div>
    <h1>公司简介</h1>
    <p style="text-align:justify">
		<span style="font-size:18px">
			<span style="line-height:2">
				<span style="font-family:Microsoft YaHei">
					&nbsp; &nbsp; 
				</span>	
					{{ companyInfo.about_us }}
			</span>
		</span>
	</p>

	<div style="margin-top: 50px;">
	    <img  :src="getFullImageUrl(companyInfo.company_image)" alt="研究院素材-德国FTA建筑设计原图-人工智能产业园夜景" title="研究院素材-德国FTA建筑设计原图-人工智能产业园夜景" id="img_smv_con_62_24" style="width: 777px; height: 518px;" class="">
	</div>
  </div>
  


</template>

<script>
import { getCompanyInfo } from '@/api/company'

export default {
  name: 'Intro',
  data() {
    return {
      companyInfo: {
        about_us: '',
      }
    }
  },
  async created() {
    await this.fetchCompanyInfo();
  },
  methods: {
    getFullImageUrl(imagePath) {
      return this.$serverUrl + imagePath;
    },
    async fetchCompanyInfo() {
      try {
        const response = await getCompanyInfo();
        if (response.data.status === 200) {
          this.companyInfo = response.data.data;
        } else {
          console.error('获取公司信息失败:', response.data.msg);
        }
      } catch (err) {
        console.error('请求出错:', err);
      }
    }
  }
};
</script>